import * as Yup from "yup";
const moment = require("moment");


export const accountSchema = Yup.object({
  // acc_name: Yup.string().min(2).max(50).required("Name is required"),
  // pgrp_start_balance: Yup.number().min(1).required("Start balance required"),
  // pgrp_end_balance: Yup.number().min(1).required("End balance required"),
});


// ALL Boiler Plate Schemas -------------

export const categorySchema = Yup.object({

  category_name: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Category Name"),

  category_logo: Yup.mixed().test('categoryLogo', 'Please Choose a Category Logo', function (value) {
    const categoryLogoPath = this.resolve(Yup.ref('category_logo_path')); // Replace with actual path field name
    if (!categoryLogoPath && !value) {
      return this.createError({
        message: 'Category Logo is required',
        path: 'category_logo',
      });
    }
    return true;
  }),

  category_banner: Yup.mixed().test('categoryBanner', 'Please Choose a Category Banner', function (value) {
    const categoryBannerPath = this.resolve(Yup.ref('category_banner_path')); // Replace with actual path field name
    if (!categoryBannerPath && !value) {
      return this.createError({
        message: 'Category Banner is required',
        path: 'category_banner',
      });
    }
    return true;
  }),


});

export const gameSchema = Yup.object({
  fk_cat_id: Yup.string()
    .min(2)
    .max(225)
    .required("Please Select Category"),
  game_name: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter Game Name"),
  game_logo: Yup.mixed().test('categoryLogo', 'Please Choose a Game Logo', function (value) {
    const categoryLogoPath = this.resolve(Yup.ref('game_logo_path')); // Replace with actual path field name
    if (!categoryLogoPath && !value) {
      return this.createError({
        message: 'Game Logo is required',
        path: 'game_logo',
      });
    }
    return true;
  }),
  game_banner: Yup.mixed().test('categoryBanner', 'Please Choose a Game Banner', function (value) {
    const categoryBannerPath = this.resolve(Yup.ref('game_banner_path')); // Replace with actual path field name
    if (!categoryBannerPath && !value) {
      return this.createError({
        message: 'Game Banner is required',
        path: 'game_banner',
      });
    }
    return true;
  }),
  game_type: Yup.string()
    .min(2)
    .max(225)
    .required("Please Select Type"),
  game_screen: Yup.string()
    .min(2)
    .max(225)
    .required("Please Select Screen"),

});

export const tncSchema = Yup.object({
  // tnc: Yup.string()
  //   .min(2)
  //   .max(225)
  //   .required("Please Enter the T & C"),

});

export const ppSchema = Yup.object({
  // privacy_policy: Yup.string()
  //   .min(2)
  //   .max(225)
  //   .required("Please Enter the Privacy Policy"),

});


export const adsMobSchema = Yup.object({
  banner: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Banner"),

  inst: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Inst Add"),
  rewarded: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Rewarded"),
  nativeadd: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Native Add"),

  openappadd: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Open App Add"),

});

export const aboutSchema = Yup.object({
  app_name: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the App Name"),
  support_email: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Support Email"),

  version: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Version"),
  about_app: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the About App"),

  user_first_name: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the First Name"),

  user_last_name: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Last Name"),

  user_designation: Yup.string()
    .min(2)
    .max(225)
    .required("Please Enter the Designation"),

});